"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eligibilityId = exports.startTimeField = void 0;
exports.startTimeField = "start_time";
exports.eligibilityId = "eligibility";
